import { ApiData } from '../../../models'
import { AuthorizationSetting } from './AuthorizationSetting';

export class AuthorizationSettingsState {
    settings: ApiData<AuthorizationSetting[]>;

    constructor () {
        this.settings = new ApiData<AuthorizationSetting[]>([])
    }
}